module.exports = __webpack_public_path__ + "static/img/cart-title.19a22b8b.png";